import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { LanguageService } from './language.service';

/** Providing supporting functions */

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  private activationStatusValues = [{ id: 1, value: this.languageService.languageJSON.Global_Inactive },
  { id: 2, value: this.languageService.languageJSON.Global_Active }];

  private approvalStatusValues = [{ id: 1, value: this.languageService.languageJSON.Global_Unapproved },
  { id: 2, value: this.languageService.languageJSON.Global_Inapproval },
  { id: 3, value: this.languageService.languageJSON.Global_Approved }];

  private rolloutStatusValues = [{ id: 1, value: this.languageService.languageJSON.RolloutStatus_New },
  { id: 2, value: this.languageService.languageJSON.RolloutStatus_InProgress },
  { id: 3, value: this.languageService.languageJSON.RolloutStatus_Stopped }];

  private rolloutUsedByOptions: { id: string, value: string, startValue: string }[] = [
    { id: "eol", value: this.languageService.languageJSON.ReleaseOverview_Eol, startValue: this.languageService.languageJSON.ReleaseOverview_StartEol },
    { id: "mobile", value: this.languageService.languageJSON.ReleaseOverview_Public, startValue: this.languageService.languageJSON.ReleaseOverview_StartPublic },
    { id: "all", value: this.languageService.languageJSON.ReleaseOverview_Both, startValue: this.languageService.languageJSON.ReleaseOverview_StartBoth }
  ];

  constructor(private datePipe: DatePipe, private languageService: LanguageService) { }

  /** Removing string from an array */
  public arrayRemove(array: string[], value: string): string[] {
    return array.filter((ele) => {
      return ele != value;
    });
  }

  public getActivationState(id: number): string {
    return this.activationStatusValues.find((el) => { return el.id == id })?.value;
  }

  public getApprovalState(id: number): string {
    return this.approvalStatusValues.find((el) => { return el.id == id })?.value;
  }

  public getRolloutState(id: number): string {
    return this.rolloutStatusValues.find((el) => { return el.id == id })?.value;
  }

  public getRolloutUsedByOptions(): { id: string, value: string, startValue: string }[] {
    return this.rolloutUsedByOptions;
  }

  public getPaginationText(itemsPerPage: number, page: number, totalItems: number): string {
    const startItem = itemsPerPage * (page - 1) + 1;

    let endItem = itemsPerPage * page;
    if (endItem > totalItems) {
      endItem = totalItems;
    }

    return `${startItem}-${endItem}/${totalItems}`;
  }

  public getFixedDateString(dateString: string): string {
    return dateString.replace("/\s/", "T") + ".000Z";
  }

  public getFixedDate(dateString: string): Date {
    return new Date(this.getFixedDateString(dateString));
  }

  public getByteCount(string: string) {
    return encodeURI(string).split(/%..|./).length - 1;
  }

  public parseCsvStringToArray(csvContent: string | undefined): string[] {
    if (csvContent) {
      let dataArray = [];
      let data = csvContent.split("\r\n");
      for (let i in data) {
        (data[i] as any) = data[i].split(",");
      }

      let maxLength = 0;
      for (let i = 0; i < data.length; i++) {
        if (data[i].length > maxLength) {
          maxLength = data[i].length;
        }
      }

      for (let i = 0; i < maxLength; i++) {
        for (let j = 0; j < data.length; j++) {
          if (data[j].length > i && data[j][i]) {
            dataArray.push(data[j][i].trim());
          }
        }
      }

      return dataArray;
    }
    return [];
  }

  public getOEMName(OEM_ID: number, oeOptionsList: { id: number, name: string }[]): string {
    if (this.isNumber(OEM_ID)) {
      return oeOptionsList.find((el) => { return el.id == OEM_ID })?.name.replace("BES_TENANT_", "") as string;
    }
    else {
      return "";
    }
  }

  public downloadCSVFile(content: string, filename: string): void {
    const blob = new Blob([content], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.download = `${filename}-${this.getActualDateForFileName()}.csv`;
    anchor.href = url;
    anchor.click();
  }

  private getActualDateForFileName(): string {
    return this.datePipe.transform(new Date(), "y-MM-dd") || "";
  }

  public isNumber(value: any): boolean {
    return typeof value === 'number';
  }
}
